import { render, staticRenderFns } from "./entry-barcode-page.vue?vue&type=template&id=0c8e2872&scoped=true&"
import script from "./entry-barcode-page.vue?vue&type=script&lang=ts&"
export * from "./entry-barcode-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8e2872",
  null
  
)

export default component.exports